import React, { useState, useEffect } from "react";
import Summary from "./printableTabs/Summary";
import Status from "./printableTabs/Status";

const PrintableBillDetails = React.forwardRef(
  ({ bill, ordinal, onLoadingComplete, billDraft }, ref) => {
    const [loadingState, setLoadingState] = useState({
      summary: { loaded: false, error: null },
      status: { loaded: false, error: null },
      fiscal: { loaded: false, error: null },
      amendments: { loaded: false, error: null },
      documentsAndLinks: { loaded: false, error: null },
    });

    const currentDate = new Date().toLocaleString();

    useEffect(() => {
      const allSectionsAttempted = Object.values(loadingState).every(
        (state) => state.loaded || state.error
      );
      if (allSectionsAttempted) {
        onLoadingComplete();
      }
    }, [loadingState, onLoadingComplete]);

    const handleSectionLoad = (section, error) => {
      onLoadingComplete();
      // setLoadingState(prevState => ({
      //   ...prevState,
      //   [section]: { loaded: true, error }
      // }));
    };

    const pageStyle = `
  @page {
    size: A4 portrait;
    margin: 15mm 10mm 20mm 10mm;
  }
    
  @media print {
    body {
      margin: 0;
      padding: 0;
      background-color: white !important;
      -webkit-print-color-adjust: exact; 
    }
    
    *{
        background: transparent !important;
        box-shadow: none !important; 
    }

    .section {
      position: relative;
      padding-top: 15mm;
      padding-bottom: 15mm;
      page-break-before: always;
    }
    .section:first-of-type {
      page-break-before: avoid;
    }
    .section-header {
      position: running(section-header);
      text-align: center;
      padding-bottom: 5mm;
      border-bottom: 1px solid #000;
    }
    .content {
      margin-top: 10mm;
    }
    .footer {
      position: running(footer);
      text-align: center;
      padding-top: 5mm;
      border-top: 1px solid #000;
    }
    @page {
      @top-center {
        content: element(section-header);
      }
      @bottom-center {
        content: element(footer);
      }
    }
  }
`;

    const renderSection = (title, Component, section) => (
      <div className="section">
        <div className="section-header">
          Bill Explorer -{" "}
          {billDraft
            ? `${billDraft.draftNumber || ""}: ${billDraft.shortTitle}`
            : `${bill.billType || ""} ${bill.number || ""}: ${bill.shortTitle}`}
          <h2 className="mt-4">{title}</h2>
        </div>
        <div className="content">
          <Component
            active={true}
            bill={bill}
            ordinal={ordinal}
            onLoad={() => handleSectionLoad(section)}
            onError={(error) => handleSectionLoad(section, error)}
          />
        </div>
      </div>
    );

    return (
      <div ref={ref}>
        <style>{pageStyle}</style>
        {renderSection("Summary", Summary, "summary")}
        {renderSection("Status", Status, "status")}
        <div className="footer">Bill Explorer - Printed on: {currentDate}</div>
      </div>
    );
  }
);

export default PrintableBillDetails;
